module.exports = __webpack_public_path__ + "static/media/fail.77f8fca5.svg";